import { render, staticRenderFns } from "./resultPage.vue?vue&type=template&id=0ff3f97a&scoped=true"
import script from "./resultPage.vue?vue&type=script&lang=js"
export * from "./resultPage.vue?vue&type=script&lang=js"
import style0 from "./resultPage.vue?vue&type=style&index=0&id=0ff3f97a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff3f97a",
  null
  
)

export default component.exports